import get from 'lodash.get';
import filter from 'lodash.filter';

// @ts-ignore
import orderBy from 'utils/custom-orderBy';

type CollectionItem = Record<string, any>;
type Collection = Record<string, CollectionItem> | CollectionItem[];
type KeyField = string;
type TextFieldFunction = (item: CollectionItem) => string;
type TextField = string | TextFieldFunction;
type OrderByField = string;
interface Parameters {
    keyField: KeyField;
    textField: TextField;
    orderByField?: OrderByField;
    filterPredicate?: Record<string, any>;
}

interface DropdownOption {
    key: boolean | number | string;
    text: string;
    value: boolean | number | string;
}

const formatDropdownOptions = (
    collection: Collection,
    parameters: Parameters
): DropdownOption[] => {
    const { keyField, textField, orderByField, filterPredicate } = parameters;

    const collectionValues = Array.isArray(collection)
        ? collection
        : Object.values(collection);

    /**
     * Assume that we don't want deleted items available in the dropdown.
     */
    const filteredCollection = filterPredicate
        ? filter(collectionValues, filterPredicate)
        : collectionValues;

    const orderedCollection: CollectionItem[] = orderBy(
        filteredCollection,
        orderByField || textField
    );

    return orderedCollection.map(
        (value): DropdownOption => {
            const keyValue = get(value, keyField);
            let textValue;
            if (typeof textField === 'function') {
                textValue = textField(value);
            } else {
                textValue = get(value, textField);
            }
            return {
                key: keyValue,
                text: textValue,
                value: keyValue
            };
        }
    );
};

export default formatDropdownOptions;
